<!-- =========================================================================================
	File Name: VerticalNavMenuGroup.vue
	Description: Vertical NavMenu Group Component. Extends vuesax framework's 'vs-sidebar-group' component
	Component Name: VerticalNavMenuGroup
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class  = "vs-sidebar-group"
    :class = "[
      {'vs-sidebar-group-open'            : openItems        },
      {'vs-sidebar-group-active'          : open             },
    ]"
    @mouseover = "mouseover"
    @mouseout  = "mouseout">

      <!-- Group Label -->
      <div @click="clickGroup" class="group-header w-full">
        <span class="flex items-center w-full">

          <!-- Group Icon -->
<!--          :svgClasses = "{ 'w-3 h-3' : this.groupIndex % 1 != 0 }" -->
          <icon-svg
            class="group-icon"
            v-if       = "group.icon"
            :icon-class = "group.icon  || 'CircleIcon'"

          />

          <!-- Group Name -->
          <span v-show="!verticalNavMenuItemsMin" class="truncate mr-3 select-none">{{  getTitle(group) }}</span>
        </span>

        <!-- Group Collapse Icon -->
        <feather-icon
          class="group-icon"
          v-show     = "!verticalNavMenuItemsMin"
          :class     = "[{'rotate90' : openItems}, 'feather-grp-header-arrow']"
          :icon       = "$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
          svg-classes= "w-4 h-4" />

        <!-- Group Tooltip -->
        <span class="vs-sidebar--tooltip">{{  getTitle(group) }}</span>
      </div>
      <!-- /Group Label -->

      <!-- Group Items -->
      <ul v-if="group.children" ref="items" :style="styleItems" class="vs-sidebar-group-items">
        <li
          class="group-under-item"
          v-for="(groupItem, index) in group.children" :key="index">

          <!-- If item is group -->
          <v-nav-menu-group
            v-if        = "groupItem.children && groupItem.children.length"
            :group      = "groupItem"
            :groupIndex = "Number(`${groupIndex}.${index+1}`)"
            :open       = "getIsGroupActive(groupItem)"
            :openHover  = "openHover" />

          <!-- Else: Item -->
<!--     props:  href 去掉 ; target 去掉   :href="groupItem.slug === 'external' ? groupItem.url : null"-->
          <v-nav-menu-item
            v-else
            icon-small
            :to="getTo(groupItem)"
            :icon   = "itemIcon(groupIndex + '.' + index)"
            :menu-item="groupItem"
            :z-index="getZindex(index)"
          >
              <span class="truncate">{{  getTitle(groupItem) }}</span>
          </v-nav-menu-item>

        </li>
      </ul>
      <!-- /Group Items -->
  </div>
</template>


<script>
  import { MenuIsExpand } from '@/utils/common'
  import { mapGetters } from 'vuex'
import VNavMenuItem from './VerticalNavMenuItem.vue'

export default {
  name  : 'v-nav-menu-group',
  props : {
    openHover  : { type: Boolean, default: false },
    open       : { type: Boolean, default: false },
    group      : { type: Object },
    groupIndex : { type: Number },
    zIndex     : { type: Number },
    to          : { type: [String, Object, null], default: null             },
  },
  components: {
    VNavMenuItem
  },
  data: () => ({
    maxHeight : '0px',
    openItems : false
  }),
  mounted() {
    this.openItems = this.open
    if (this.open) { this.maxHeight = 'none' }
  },
  computed: {
    ...mapGetters(['language']),
    verticalNavMenuItemsMin() { return this.$store.getters.verticalNavMenuItemsMin },
    styleItems() {
      return { maxHeight: this.maxHeight }
    },
    itemIcon() {
      return (index) => {
        if (!((index.match(/\./g) || []).length > 1)) return "CircleIcon"
      }
    },

  },
  watch: {
    // OPEN & CLOSES DROPDOWN ON ROUTE CHANGE
    '$route'() {
      if (this.verticalNavMenuItemsMin) return

      let scrollHeight = this.scrollHeight

      // Collapse Group
      if (this.openItems && !this.open) {

        this.maxHeight = `${scrollHeight}px`
        setTimeout(()  => {
          this.maxHeight = `${0}px`
        }, 50)

      // Expand Group
      } else if (this.open) {

        this.maxHeight = `${scrollHeight}px`
        setTimeout(()  => {
          this.maxHeight = 'none'
        }, 300)
      }
    },
    maxHeight() {
      this.openItems = this.maxHeight != '0px'
    },
    // OPEN AND CLOSES DROPDOWN MENU ON NavMenu COLLAPSE AND DEFAULT VIEW
    '$store.getters.verticalNavMenuItemsMin'(val) {
      let scrollHeight = this.$refs.items.scrollHeight

      if (!val && this.open) {

        this.maxHeight = `${scrollHeight}px`
        setTimeout(()  => {
          this.maxHeight = 'none'
        }, 300)
      } else {

        this.maxHeight = `${scrollHeight}px`
        setTimeout(()  => {
          this.maxHeight = '0px'
        }, 50)
      }
      if (val && this.open) {

        this.maxHeight = `${scrollHeight}px`
        setTimeout(()  => {
          this.maxHeight = '0px'
        }, 250)
      }
    }
  },
  methods: {
    getIsGroupActive(menu) {

      return MenuIsExpand(menu,this);
    },
    getTitle(item){
      return item.name;
    },
    getTo(item){

      return {name: item.componentName};
    },
    clickGroup() {
      if (!this.openHover) {

        let thisScrollHeight = this.$refs.items.scrollHeight

        if (this.maxHeight == '0px') {
          this.maxHeight = `${thisScrollHeight}px`
          setTimeout(() => {
            this.maxHeight = 'none'
          }, 300)

        } else {
          this.maxHeight = `${thisScrollHeight}px`
          setTimeout(() => {
            this.maxHeight = `${0}px`
          }, 50)
        }

        this.$parent.$children.map((child) => {
          if (child.isGroupActive) {
            if (child !== this && (!child.open) && child.maxHeight != '0px') {
              setTimeout(() => {
                child.maxHeight = `${0}px`
              }, 50)
            }
          }
        })
      }
    },
    mouseover() {
      if (this.openHover) {
        let scrollHeight = this.$refs.items.scrollHeight
        this.maxHeight   = `${scrollHeight}px`
      }
    },
    mouseout() {
      if (this.openHover) {
        let scrollHeight = 0
        this.maxHeight   = `${scrollHeight}px`
      }
    },
    getZindex(index){
      return Number(this.groupIndex + '' + index);
    }
  },

}

</script>


<style lang="scss">
@import "@/assets/scss/vuexy/components/verticalNavMenuGroup.scss"
</style>
<style lang="scss" scoped>
  .vs-sidebar-group-items {
    /*.group-under-item {
      padding-left: 10px;
    }*/
  }
  .group-icon {
    margin-right: 10px;
    font-size: 20px!important;
  }
</style>
